import {
  experimental_streamedQuery as streamedQuery,
  keepPreviousData,
  QueryClient,
  QueryClientProvider,
  queryOptions,
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"

import { retryOnlyServerErrors } from "./apiErrors"

const queryDefaults = {
  // Keep all re-fetches disabled by default.
  // Enable what's needed. Some cases like Infinite-loading tables can get weird otherwise.
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
  // See utils/apiErrors for what this does and does not retry.
  retry: retryOnlyServerErrors(3),
}

const queryClient = new QueryClient({ defaultOptions: { queries: queryDefaults } })

export const ReactQueryProvider = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

ReactQueryProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useReactQueryClient = () => useQueryClient()

export { keepPreviousData, queryOptions, streamedQuery, useInfiniteQuery, useMutation, useQuery }

export const createTestQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      ...queryDefaults,
      // Query-level retry options still take precedence over this default.
      retry: false,
    },
  },
})

const testQueryClient = createTestQueryClient()

export const MockReactQueryProvider = ({ children, client = testQueryClient }) => {
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}

export const clearTestQueryCache = () => testQueryClient.clear()

MockReactQueryProvider.propTypes = {
  children: PropTypes.node.isRequired,
  client: PropTypes.instanceOf(QueryClient),
}
